export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f684329f956db37de071f79fb73fceb19ede11e56&name=fetchTypeahead!'